import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TestimonialCarousel as TestimonialCarouselZDS, Img, } from '@zapier/design-system';
import { RichText } from '../RichText';
import { DEFAULT_VALUES } from './fixtures';
import { Video } from '../Video';
export function TestimonialCarousel({ backgroundColor, testimonials = [], }) {
    return (_jsx(TestimonialCarouselZDS, { backgroundColor: backgroundColor || DEFAULT_VALUES.backgroundColor, testimonials: testimonials.map((testimonial) => {
            var _a;
            return Object.assign(Object.assign({}, testimonial), { quote: (_jsx(RichText, { backgroundColor: backgroundColor, html: testimonial.quote })), mediaElement: (testimonial.mediaURL && (_jsx(Img, { src: testimonial.mediaURL || '', alt: testimonial.mediaAltText || '' }))) ||
                    (((_a = testimonial.video) === null || _a === void 0 ? void 0 : _a.videoUrl) && _jsx(Video, Object.assign({}, testimonial.video))) });
        }) }));
}
//# sourceMappingURL=TestimonialCarousel.js.map